import React from "react";

import styles from "./style.module.scss";

const InstructionItem = ({ icon, title, titleIcon, text }) => {
  return (
    <div className={styles.container}>
      <img src={icon} alt="icon" className={styles.icon} />
      <div className={styles.itemContent}>
        <span className={styles.itemTitle}>
          {title} {titleIcon}
        </span>
        <div className={styles.itemText}>{text}</div>
      </div>
    </div>
  );
};

export default InstructionItem;
